import { render, staticRenderFns } from "./HRManagement.vue?vue&type=template&id=35029dc8&lang=pug&"
import script from "./HRManagement.vue?vue&type=script&lang=js&"
export * from "./HRManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports